'use client';

import React from 'react';

interface DividerProps {
  className?: string;
  vertical?: boolean;
}

const Divider = ({ className = '', vertical = false }: DividerProps) => {
  return <span className={`${className} relative border-[initial] ${!vertical && 'block h-0 border-b'}`}>{vertical && '|'}</span>;
};

export default Divider;
